module.exports = __webpack_public_path__ + "static/img/ygbx.d9cf3b33.png";